import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Stack,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import React, { useContext, useState } from "react";
import MainForm from "../MainForm/MainForm";
import TableServicesData from "../DataGridServicesData/DataGridServicesData";
import { Helmet } from "react-helmet-async";
import { CheckedServicesContext } from "../Context/CheckedServicesContextWrapper";

const CheckedServicesMainPage = () => {
  const [selectedTab, setSelectedTab] = useState<number>(0);

  const context = useContext(CheckedServicesContext);

  const handleResetForm = () => {
    context?.setLoadingDataSpunte(null);
    context?.setColonne([]);
    context?.setRecords([]);
    context?.methodsFormCheckedServices.reset();
  };

  return (
    <Box sx={{ display: "flex", height: "100%", width: "100%"}}>
      <Helmet>
        <title>Spunta Prestazioni Effettuate</title>
      </Helmet>
      {context?.dataSpunteParams?.esito ? (
        <Box sx={{ display: "flex", width: "100%", height: "100%"}}>
          <Grid
            container
            sx={{ backgroundColor: "#F8F8F8", p: 3, display: "flex", height: "100%", width: "100%"}}
          >
            {/* <AllertMessage
          showAllert={showAllert}
          setShowAllert={setShowAllert}
          severity={severity}
          message={message}
          submitFunction={moveAppointments}
          // showSummary={props.handleSummaryTableOpening}
        /> */}
            <Grid item xs={12} mb={2}>
              <Typography sx={{ fontWeight: "bold" }}>
                Spunta prestazioni effettuate
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Tabs value={selectedTab} onChange={() => setSelectedTab(0)}>
                <Tab
                  sx={{
                    fontFamily: "Montserrat",
                    fontWeight: "bold",
                    textTransform: "none",
                  }}
                  label="Dettaglio"
                />
              </Tabs>
            </Grid>
            <Grid item xs={12} pt={3} pb={1}>
              <MainForm />
            </Grid>
            {context?.loadingDataSpunte !== null && (
              <Grid
                item
                xs={12}
                sx={{ display: "flex", height: "100%", width: "100%" }}
                mt={2}
              >
                {context?.loadingDataSpunte === false ? (
                  <Box
                    sx={{
                      flexDirection: "column", height: "45vh" , width: "100vw"
                    }}
                  >
                    <TableServicesData />
                  </Box>
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      height: "50vh",
                      width: "100%",
                      alignItems: "center",
                      alignContent: "center",
                      justifyContent: "center",
                      justifyItems: "center",
                    }}
                  >
                    <CircularProgress size="6rem" />
                  </Box>
                )}
              </Grid>
            )}
            {context?.loadingDataSpunte === false && (
              <Grid item xs={12} mt={2}>
                <Stack
                  direction="row"
                  spacing={1}
                  display={"flex"}
                  justifyContent={"flex-end"}
                >
                  <Button
                    variant="outlined"
                    onClick={() => console.log("Agg. Spunte")}
                  >
                    Agg. Spunte
                  </Button>
                  <Button variant="outlined" onClick={() => handleResetForm()}>
                    Nuova Ricerca
                  </Button>
                </Stack>
              </Grid>
            )}
          </Grid>
        </Box>
      ) : (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            zIndex: 1300,
          }}
        >
          <CircularProgress size="6rem" />
        </Box>
      )}
    </Box>
  );
};

export default CheckedServicesMainPage;
